export enum FormState {
  Loading,
  Submitting,
  Normal,
  Complete,
}
